import { SORT_ORDER } from '@evinced-private/ui-common';

import { preprocessSearchValue } from 'src/apps/mobile-common/helpers/MobileSearchHelper';
import { IGetMobileSdkTestIssuesParams } from 'src/apps/mobile-sdk/services/MobileSdkDashboardServiceTypes';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	IssuesSortFields,
	IssuesSortOrder,
	IssuesTextSearchFields
} from 'src/common/types/graphql.generated';

import { MobileSdkTestIssuesQueryVariables } from '../MobileSdkTestIssues.generated';

const issuesSortFieldNamesMap: Record<string, IssuesSortFields> = {
	type: IssuesSortFields.TypeName,
	severity: IssuesSortFields.SeverityName,
	scanName: IssuesSortFields.ScanName
};

const issuesSortOrderMap: Record<SORT_ORDER, IssuesSortOrder> = {
	[SORT_ORDER.ASC]: IssuesSortOrder.Ascending,
	[SORT_ORDER.DESC]: IssuesSortOrder.Descending
};

const issuesSearchFields = [
	IssuesTextSearchFields.TypeName,
	IssuesTextSearchFields.SeverityName,
	IssuesTextSearchFields.ScanName,
	IssuesTextSearchFields.ElementsAccessibilityLabel,
	IssuesTextSearchFields.ElementsAccessibilityIdentifier,
	IssuesTextSearchFields.ElementsElementType,
	IssuesTextSearchFields.ElementsContentDescription,
	IssuesTextSearchFields.ElementsViewId,
	IssuesTextSearchFields.ElementsClassName,
	IssuesTextSearchFields.ElementsId,
	IssuesTextSearchFields.ElementsIndex,
	IssuesTextSearchFields.ElementsComponentId
];

const SEVERITY_ID_FILTER_PARAM_NAME = 'severityIdFilter';
const TYPE_ID_FILTER_PARAM_NAME = 'typeIdFilter';
const SCAN_ID_FILTER_PARAM_NAME = 'scanIdFilter';

export const buildMobileSdkTestIssuesQueryVariables = ({
	testId,
	pageSize = 10,
	page = 0,
	sort,
	filterOptions
}: IGetMobileSdkTestIssuesParams): MobileSdkTestIssuesQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileSdkTestIssuesQueryVariables>({
		searchFields: issuesSearchFields,
		sortFieldsMap: issuesSortFieldNamesMap,
		sortOrderMap: issuesSortOrderMap
	});

	const searchValues = preprocessSearchValue(filterOptions?.searchValue ?? '');

	return variablesBuilder
		.addPaginationParams(page, pageSize)
		.addSortParam(sort)
		.addTextSearchParam(searchValues)
		.addConditionParam('testId', testId)
		.addFilterParam(SEVERITY_ID_FILTER_PARAM_NAME, filterOptions?.severities)
		.addFilterParam(TYPE_ID_FILTER_PARAM_NAME, filterOptions?.types)
		.addFilterParam(SCAN_ID_FILTER_PARAM_NAME, filterOptions?.scans)
		.getVariables();
};
